import { render, staticRenderFns } from "./target_compare.vue?vue&type=template&id=acdd1b5a&scoped=true"
import script from "./target_compare.vue?vue&type=script&lang=js"
export * from "./target_compare.vue?vue&type=script&lang=js"
import style0 from "./target_compare.vue?vue&type=style&index=0&id=acdd1b5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdd1b5a",
  null
  
)

export default component.exports